const CTA_BASE_URL = 'https://cta-redirect.hubspot.com';
const CTA_REDIRECT_PATH = `${CTA_BASE_URL}/cta/redirect/11964`;

export const CTA_SALES_PRO_MONTHLY_ID = 'f77dfbfc-375f-458a-a1be-91a696692ded';
export const CTA_SALES_PRO_MONTHLY_URL = `${CTA_REDIRECT_PATH}/${CTA_SALES_PRO_MONTHLY_ID}`;

export const CTA_SALES_PRO_YEARLY_ID = 'ccc32248-92e9-40d2-8f62-324360d5151a';
export const CTA_SALES_PRO_YEARLY_URL = `${CTA_REDIRECT_PATH}/${CTA_SALES_PRO_YEARLY_ID}`;

/**
 * How long `GET v1/subscriptions/plans` is allowed to hang before
 * `/pricing`/`/plans` and `/new-plan/:id` treat it as failed (issue #600
 * AC-4). A request that never answers must still resolve to the in-page
 * error state instead of leaving the loading placeholder up forever.
 */
export const PLANS_LOAD_TIMEOUT_MS = 15000;
